import React from 'react';
import {
  isCfVerzekeringenFlow,
  isCustomerCheckupFlow,
  isRiskAnalysisFlow,
} from '../../../../../../common/src/utils/globalVariables';
import MultiSelectRiskAnalysis from '../../../../../../risk-analysis/src/components/input/MultiSelectInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MultiselectInputComponentAdvisory from './MultiselectInputComponent';

interface Props {
  question: FlowsQuestion;
}

const MultiselectDetailedPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (
    isRiskAnalysisFlow() ||
    isCustomerCheckupFlow() ||
    isCfVerzekeringenFlow()
  ) {
    return <MultiSelectRiskAnalysis question={question} />;
  }

  return <MultiselectInputComponentAdvisory question={question} />;
};

export default MultiselectDetailedPicker;
